var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"hide"}},[(_vm.closed)?_c('div',{staticClass:"curtain",attrs:{"id":"curtain"}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }